module.exports = __webpack_public_path__ + "static/media/renshibankuai3.f1cd6365.png";